import styled from "styled-components";
import media from "constants/media";
import NextImage from "next/image";

export const SimpleHero = styled.div`
    position: relative;

    display: flex;
    height: 380px;
    padding: 0 10%;

    background-color: #00174b;

    ${media.mdUp`
        height: 530px;
        position: relative;

        align-items: flex-start;
        padding: 16px calc((100% - 1160px)/2) 0 calc((100% - 1180px)/2);
    `}
`;

export const BackgroundImage = styled.div`
    position: absolute;
    right: -100px;
    z-index: 0;

    width: 480px;
    height: 1705px;

    background: url("/images/pdp-letters-mobile.svg") no-repeat top center;

    ${media.mdUp`
        right: 0;
        top: 0;

        width: 653px;
        height: 1200px;


        background: url("/images/pdp-letters-desktop.svg") no-repeat top center;
    `}
`;

export const BannerCard = styled.div`
    position: relative;

    display: flex;
    flex-direction: column;
    width: 95%;
    max-width: 480px;
    margin: -360px auto 0;

    color: #fff;

    ${media.mdUp`
        left: 1%;
        margin: 0;
        position: absolute;
        top: 300px;
        width: 40%;
    `}

    ${media.lgUp`
        left: calc((100% - 1160px) / 2);
    `}
`;

export const Image = styled(NextImage)`
    position: relative;
    z-index: 1;

    width: 100%;
    margin-top: 5px;

    ${media.mdUp`
        margin-top: 0;
    `}
`;

export const InfoAboutUs = styled.div`
    display: flex;
    flex-direction: column;
    width: 90%;
    max-width: 400px;
    margin: 48px auto 40px;

    ${media.mdUp`
        width: 100%;
        max-width: 480px;
        margin-top: 30px;
    `}
`;
